<svg class="mapa" [attr.viewBox]="viewBox" role="img"
    [attr.aria-label]="tipo === 'andamento' ? 'Andamento da consulta por UF' : tipo === 'situacao' ? 'UFs carregadas na tabela' : 'Resultado da importação por UF'">
    @for (caminhoUf of listaCaminhoUf; track caminhoUf.sigla) {
        <path class="uf" [attr.d]="caminhoUf.d"
            [class.uf-concluida]="situacaoPorUf[caminhoUf.sigla] === 'concluida'"
            [class.uf-parcial]="situacaoPorUf[caminhoUf.sigla] === 'parcial'"
            [class.uf-falhou]="situacaoPorUf[caminhoUf.sigla] === 'falhou'"
            [class.uf-consultada]="situacaoPorUf[caminhoUf.sigla] === 'consultada'"
            [class.uf-em-consulta]="situacaoPorUf[caminhoUf.sigla] === 'emConsulta'"
            [class.uf-carregada]="situacaoPorUf[caminhoUf.sigla] === 'carregada'">
            <title>{{ caminhoUf.nome }}: {{ descricaoSituacao(caminhoUf.sigla) }}</title>
        </path>
    }
</svg>

<div class="legenda">
    @if (tipo === 'andamento') {
        <span class="legenda-item"><span class="legenda-cor uf-consultada"></span>Consultada</span>
        <span class="legenda-item"><span class="legenda-cor uf-em-consulta"></span>Em consulta</span>
        <span class="legenda-item"><span class="legenda-cor"></span>A consultar</span>
    } @else if (tipo === 'situacao') {
        <span class="legenda-item"><span class="legenda-cor uf-carregada"></span>Carregada</span>
        <span class="legenda-item"><span class="legenda-cor"></span>Sem tabela</span>
    } @else {
        <span class="legenda-item"><span class="legenda-cor uf-concluida"></span>Concluída</span>
        <span class="legenda-item"><span class="legenda-cor uf-parcial"></span>Parcial</span>
        <span class="legenda-item"><span class="legenda-cor uf-falhou"></span>Falhou</span>
        <span class="legenda-item"><span class="legenda-cor"></span>Não enviada</span>
    }
</div>
